/**
 * Horizontal carousel for explore-the-features section (Figma: peek slides + right control).
 */
class ExploreFeaturesSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-etf-slider]');
    this.nextBtn = this.querySelector('[data-etf-next]');
    this.prevBtn = this.querySelector('[data-etf-prev]');
    if (!this.track || !this.nextBtn) return;

    this.readGap();

    this.track.setAttribute('tabindex', '0');
    this.track.addEventListener('keydown', this.onKeydown.bind(this));
    this.nextBtn.addEventListener('click', () => this.move(1));
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.move(-1));
    }

    this.track.addEventListener('scroll', () => this.sync(), { passive: true });
    window.addEventListener('resize', () => this.onResize(), { passive: true });

    requestAnimationFrame(() => this.sync());
  }

  readGap() {
    const g = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap);
    this.gap = Number.isFinite(g) ? g : 24;
  }

  onResize() {
    this.readGap();
    requestAnimationFrame(() => this.sync());
  }

  getStep() {
    const slide = this.track.querySelector('.etf__slide');
    if (!slide) return 0;
    return slide.getBoundingClientRect().width + this.gap;
  }

  move(direction) {
    const step = this.getStep();
    if (!step) return;
    this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  onKeydown(event) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.move(1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.move(-1);
    }
  }

  sync() {
    const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
    const left = this.track.scrollLeft;
    if (this.prevBtn) {
      const atStart = left <= 2;
      this.prevBtn.hidden = atStart;
      if (atStart) {
        this.prevBtn.setAttribute('aria-hidden', 'true');
      } else {
        this.prevBtn.removeAttribute('aria-hidden');
      }
    }
    if (left >= max) {
      this.nextBtn.setAttribute('disabled', 'disabled');
    } else {
      this.nextBtn.removeAttribute('disabled');
    }
  }
}

customElements.define('explore-features-slider', ExploreFeaturesSlider);
